<template>
<div>
    <v-snackbar
      v-model="snackbar"
    >
      Convite para integrar o grupo foi enviado com sucesso.
      <template v-slot:action="{ attrs }">
        <v-btn
          color="#F15A24"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  <v-menu bottom  offset-x left v-model="menuShow" :close-on-content-click="false" transition="scale-transition">

    <template v-slot:activator="{ on, attrs }">
      <v-btn dark color="#F15A24" v-bind="attrs" v-on="on">
        <v-icon >mdi-plus</v-icon>
        Convidar Integrante
      </v-btn>
    </template>
    <v-card width="400" class="text-center" elevation="2" sytle="max-width:450px; overflow-x:auto">
      <v-card-title>Convidar Integrante</v-card-title>
      <v-card-text>
          <input type="text" placeholder="Pesquise pelo nome" v-model="searchUser"
            style="width: 70%; margin-right:15px; padding: 0.3rem"  />
            <button :disabled="loadingUsers" @click="filterUsers()" class="btn btn-secondary pa-2" style="
              border-radius: 5px;
              background-color: #F15A24;
              color: white;
             
              padding: 0.2rem;
            ">
            <v-progress-circular v-if="loadingUsers" indeterminate></v-progress-circular>
            <span v-if="!loadingUsers">Pesquisar</span>
          </button>
          <v-list class="mt-3" style="max-height:60vh; overflow-y: auto;" >
            <v-list-item v-if="filteredUsers.length === 0">
              <v-list-item-content class="d-flex justify-center">
                 {{searched ? `O nome digitado não foi encontrado` : `Digite o nome do integrante e clique em pesquisar`}} 
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="user in filteredUsers" :key="user.id" 
              class="chip-with-hover " style="padding: 0.2rem; margin-bottom: 0.2rem;">
              <v-list-item-icon class="d-flex justify-center mr-3">
                <v-icon size="40px" v-if="!user.avatar" color="#F15A24" >
                  mdi-account
                </v-icon>
                <img width="40px" v-if="user.avatar" height="40px" class="rounded-circle" 
									:src="`https://api.mylegis.com.br/assets/${user.avatar}`" />
              </v-list-item-icon>
              <v-list-item-content class="text-left">
                <v-list-item-title>
                
                  {{ user.first_name }} {{ user.last_name || "" }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="#F15A24" text small @click="adicionar(user)" :disabled="user.adicionado">{{user.adicionado ? `Convidado` : `Convidar` }}</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          </v-card-text>
    </v-card>
  </v-menu>
</div>
</template>
<style scoped>
.chip-with-hover:hover {
  border: 1px solid #f15a24;
  border-radius: 5px;
}
</style>
<script>
export default {
  name: "BtnAdicionarGrupo",
  props: { link: String, titulo: String, reloadFriends: Function, idGrupo: String, integrantes: Array, reloadIntegrantes: Function },
  data() {
    return {
      menuShow: false,
      snackbar: false,
      values: [],
      searchUser: "",
      usersToAdd: [],
      filteredUsers: [],
      loadingUsers: false,
      searched: false
    };
  },
  mounted() {
  //    this.getUsuarios()
  },
  computed: { 
    users() { 
      return this.$store.state.users
    }
  },
  methods: {
    adicionar(user) {
      let share = { 
        status: "pendente",
        id_grupo: this.$props.idGrupo,
        id_usuario: user.id
      };

      this.$http.post("items/add_grupos", share).then((response) => {
        if (response.data.data.id != undefined) {
          // this.menuShow = false;
          this.snackbar = true;
          user.adicionado=true
          this.reloadIntegrantes();
          // this.cleanFields();
        }
      });
    },
    cleanFields() {
      this.filteredUsers = [];
      this.searchUser = "";
      this.searched = "";
    },
    async filterUsers() {
      if (this.searchUser === "") { this.cleanFields(); return }
      this.searched=true
      this.loadingUsers = true
      this.searchUser = this.searchUser.trim()
      await this.$store.dispatch("searchUsuarios", this.searchUser)
      this.filteredUsers = this.users
      this.loadingUsers = false
    },
  },
};
</script>
